export { default } from './WifiAttackModal.jsx';
